/**
 * Options required to prioritise which icon to show
 */

/**
 * Reusable priority function for choosing which icon to show.
 * Generic so it can be used to prioritise strings, or React components depending on the usage.
 */
export function prioritiseIcon(_ref) {
  var fileFormatIcon = _ref.fileFormatIcon,
    documentTypeIcon = _ref.documentTypeIcon,
    urlIcon = _ref.urlIcon,
    providerIcon = _ref.providerIcon;
  return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}